export default () => {

    const scroll = document.querySelector('#scroll');
    const keyframes = {
        translate: ['-100% 0', '100% 0']
    };
    const options = {
        duration: 1300,
        delay: 500,
        easing: 'linear',
        iterations: Infinity,
    };

    scroll.animate(keyframes, options);

}